import Vue from 'vue'
import pagination from 'vuejs-uib-pagination'

Vue.use(pagination)
